module.exports = __webpack_public_path__ + "73ce7f24de2adb80d6dee0882e6aaba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/6.jpg
// module id = 289
// module chunks = 0